import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { API } from "../../data/site";
import { AdminButton } from "../ui";
import { Home, FileText, Briefcase, MessageSquare, Camera, Inbox } from "lucide-react";

const StatCard = ({ label, value, testid }) => (
  <div className="bg-white border border-[rgba(26,26,26,0.1)] p-6" data-testid={testid}>
    <p className="font-serif text-5xl tracking-tight">{value}</p>
    <p className="eyebrow text-[#5C5A56] mt-2">{label}</p>
  </div>
);

const DashboardPanel = ({ go }) => {
  const { data: stats } = useQuery({
    queryKey: ["admin-stats"],
    queryFn: async () => (await axios.get(`${API}/admin/stats`, { withCredentials: true })).data,
  });

  if (!stats) return <p className="font-mono text-xs tracking-[0.2em] uppercase text-[#A3A09B]">Loading…</p>;

  return (
    <div data-testid="dashboard-panel">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        <StatCard label="Homes For Sale" value={stats.active_homes} testid="stat-active-homes" />
        <StatCard label="Coming Soon" value={stats.pending_homes} testid="stat-pending-homes" />
        <StatCard label="Sold Homes" value={stats.sold_homes} testid="stat-sold-homes" />
        <StatCard label="Floor Plans" value={stats.floor_plans} testid="stat-plans" />
        <StatCard label="Projects" value={stats.projects} testid="stat-projects" />
        <StatCard label="Testimonials" value={stats.testimonials} testid="stat-testimonials" />
        <StatCard label="New Inquiries" value={stats.new_leads} testid="stat-new-leads" />
        <StatCard label="Photos & Files" value={stats.media} testid="stat-media" />
      </div>

      <p className="eyebrow text-[#8C6A4F] mt-12 mb-5">Quick Actions</p>
      <div className="flex flex-wrap gap-3">
        <AdminButton primary onClick={() => go("homes", "new")} testid="quick-add-home"><span className="inline-flex items-center gap-2"><Home size={13} /> Add Home</span></AdminButton>
        <AdminButton onClick={() => go("plans", "new")} testid="quick-add-plan"><span className="inline-flex items-center gap-2"><FileText size={13} /> Add Floor Plan</span></AdminButton>
        <AdminButton onClick={() => go("projects", "new")} testid="quick-add-project"><span className="inline-flex items-center gap-2"><Briefcase size={13} /> Add Project</span></AdminButton>
        <AdminButton onClick={() => go("testimonials", "new")} testid="quick-add-testimonial"><span className="inline-flex items-center gap-2"><MessageSquare size={13} /> Add Testimonial</span></AdminButton>
        <AdminButton onClick={() => go("photos")} testid="quick-upload-photos"><span className="inline-flex items-center gap-2"><Camera size={13} /> Upload Photos</span></AdminButton>
        <AdminButton onClick={() => go("leads")} testid="quick-view-leads"><span className="inline-flex items-center gap-2"><Inbox size={13} /> View Leads</span></AdminButton>
      </div>

      <p className="eyebrow text-[#8C6A4F] mt-12 mb-5">Recent Activity</p>
      <div className="bg-white border border-[rgba(26,26,26,0.1)] divide-y divide-[rgba(26,26,26,0.06)]" data-testid="activity-feed">
        {stats.activity.length === 0 && <p className="p-6 text-sm text-[#A3A09B]">No activity yet.</p>}
        {stats.activity.map((a, i) => (
          <div key={i} className="flex items-center justify-between px-6 py-4">
            <span className="text-sm text-[#1A1A1A]">
              <span className={`inline-block w-2 h-2 rounded-full mr-3 ${a.type === "lead" ? "bg-[#8C6A4F]" : "bg-[#4E735B]"}`} />
              {a.label}
            </span>
            <span className="font-mono text-[0.62rem] tracking-wider text-[#A3A09B]">{a.at ? new Date(a.at).toLocaleDateString() : ""}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashboardPanel;
